<template>
  <div>
    <div class="container-fluid content pt-md-1"
         :class="{'pt-3 pt-md-1':!hasTopHeader}">
      <div class="d-block fixed-top border-bottom border-light d-md-none">
        <slot name="fixed-top"></slot>
      </div>
      <div>
        <slot name="heading"></slot>
      </div>
      <div class="row mt-2">
        <div class="col-12 px-2"
             :class="{'col-md-7': !onlyMain}">
          <div>
            <slot name="main"></slot>
          </div>
        </div>
        <div class="col-12 col-md-5 mt-3 mt-md-0"
             v-if="$mq !== 'mobile' && !onlyMain">
          <div class="mb-3">
            <slot name="right1"></slot>
          </div>
          <div>
            <slot name="right2"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    onlyMain: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasTopHeader() {
      return !!this.$slots['fixed-top']
    },
    hasHeading() {
      return !!this.$slots['heading']
    }
  }
}
</script>
